import { render, staticRenderFns } from "./FormDeleteWardenPopup.vue?vue&type=template&id=764a3a72&scoped=true"
import script from "./FormDeleteWardenPopup.vue?vue&type=script&lang=js"
export * from "./FormDeleteWardenPopup.vue?vue&type=script&lang=js"
import style0 from "./FormDeleteWardenPopup.vue?vue&type=style&index=0&id=764a3a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a3a72",
  null
  
)

export default component.exports